import type { SanityPageBuilderSection, SanityPageBuilderSpecsListSection, SanityPageBuilderSpecsListSpec } from "@ouster/shared";
import { SpecsListBlockView } from "~/features/blocks/inventory/specs-list";
import { SpecsListSpecView } from "~/features/blocks/inventory/specs-list/spec-list-spec";
import { toCraftLinkArray } from "~/features/sanity/link";
import type { Mode, Theme } from "~/features/ui/get-theme-style";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderSpecsListSection;
  };
};
type SpecsListViewSpec = {
  _key?: SanityPageBuilderSpecsListSpec["_key"];
  subTitle?: SanityPageBuilderSpecsListSpec["subTitle"];
  title?: SanityPageBuilderSpecsListSpec["title"];
};
export function SanitySpecsListSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const mode = (sectionSettings?.mode || "light") as Mode;
  const theme = (sectionSettings?.theme || "white") as Theme;
  const hasBorder = sectionContent.hasBorder ?? true;
  const specs = sectionContent.specs?.map<SpecsListViewSpec>(spec => ({
    _key: spec._key,
    subTitle: spec.subTitle,
    title: spec.title
  })) ?? [];
  return <SpecsListBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} columns={sectionContent.columns} getItemKey={(spec, index) => spec._key || index} hasBorder={hasBorder} hasTopDivider={sectionSettings?.hasTopDivider ?? true} isHighlighted={sectionContent.isHighlighted} layout={sectionContent.layout} link={toCraftLinkArray(sectionContent.link)} mode={mode} renderSpec={spec => <SpecsListSpecView mode={mode} subTitle={spec.subTitle} theme={theme} title={spec.title} />} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} specs={specs} theme={theme} />;
}